import { formatLimit } from './format_limit'

const isLimitSet = (limit) => limit !== undefined && limit !== null && limit !== ''

export const getFormatValuesToServerData = (eventType) => (values) => {
  const shouldSave = eventType.event_limit?.uuid
    || isLimitSet(values.dailyLimit)
    || isLimitSet(values.weeklyLimit)
    || isLimitSet(values.monthlyLimit)

  return shouldSave ? {
    event_limit_attributes: {
      daily_limit: formatLimit(values.dailyLimit),
      weekly_limit: formatLimit(values.weeklyLimit),
      monthly_limit: formatLimit(values.monthlyLimit)
    }
  } : {}
}
